// Simplified Product Search System - Fixed Syntax (Flipside-first + de-dupe + price fixes)
document.addEventListener('DOMContentLoaded', function() {
  console.log('Product Search Starting...');

  // Configuration
  const CONFIG = {
    PRODUCTS_PER_PAGE: 48,
    MAX_REQUESTS: 2,
    REQUEST_DELAY: 300
  };

  // State
  let allProducts = window.serverProducts || [];
  let filteredProducts = [];
  let currentPage = 1;
  let totalPages = 1;
  let activeFilters = { search: '', vendor: '', type: '' };
  let isLoading = false;

  // ---- Helpers ----
  const normHandle = h => (h || '').trim().toLowerCase();
  const cents = v => {
    if (v == null) return 0;
    const n = typeof v === 'string' ? parseFloat(v) : Number(v);
    if (!isFinite(n) || isNaN(n)) return 0;
    if (n > 1000 && Number.isInteger(n)) return Math.round(n); // already cents
    return Math.round(n * 100); // dollars -> cents
  };
  const scoreProduct = p => {
    let s = 0;
    if (p.price && p.price > 0) s += 10;
    if (p.image) s += 3;
    if (p.vendor) s += 1;
    if (p.type) s += 1;
    if (p.variants && p.variants.length && p.variants[0].id) s += 5;
    return s;
  };
  const dedupeAll = list => {
    const map = new Map();
    for (const p of list) {
      const h = normHandle(p.handle);
      if (!h) continue;
      const ex = map.get(h);
      if (!ex || scoreProduct(p) > scoreProduct(ex)) map.set(h, p);
    }
    return Array.from(map.values());
  };

  // De-dupe any server seed right away
  allProducts = dedupeAll(allProducts);

  // DOM Elements
  const productGrid = document.getElementById('product-list');
  const searchInput = document.getElementById('search-input');
  const clearFiltersBtn = document.getElementById('clear-filters');
  const clearSearchBtn = document.getElementById('clear-search-btn');
  const loadingIndicator = document.getElementById('loading-indicator');
  const totalProductsCount = document.getElementById('total-products-count');

  // Initialize
  init();

  function init() {
    console.log('Starting with', allProducts.length, 'products');

    buildFilters();
    applyFilters();
    setupEventListeners();

    // Start background loading
    setTimeout(startBackgroundLoading, 1000);
  }

  function setupEventListeners() {
    if (searchInput) {
      searchInput.addEventListener('input', debounce(handleSearch, 300));
    }

    if (clearFiltersBtn) {
      clearFiltersBtn.addEventListener('click', clearAllFilters);
    }

    if (clearSearchBtn) {
      clearSearchBtn.addEventListener('click', clearSearch);
    }

    // Filter checkboxes
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('filter-checkbox')) {
        handleFilterChange(e.target);
      }
    });

    // Pagination clicks
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('quick-add-btn') && !e.target.disabled) {
        handleQuickAdd(e.target);
      }

      if (e.target.id === 'prev-page' && currentPage > 1) {
        currentPage--;
        updateProductDisplay();
      }

      if (e.target.id === 'next-page' && currentPage < totalPages) {
        currentPage++;
        updateProductDisplay();
      }

      if (e.target.classList.contains('page-number')) {
        currentPage = parseInt(e.target.dataset.page, 10);
        updateProductDisplay();
      }
    });

    // Global search function
    window.performSearch = function(searchTerm) {
      if (searchInput) searchInput.value = searchTerm || '';
      activeFilters.search = (searchTerm || '').toLowerCase();
      applyFilters();
    };

    window.clearSearch = function() {
      if (searchInput) searchInput.value = '';
      activeFilters.search = '';
      applyFilters();
    };
  }

  // Filter toggle function
  window.toggleFilter = function(filterType) {
    const content = document.getElementById(filterType + '-filter-content');
    const toggle = document.getElementById(filterType + '-toggle');
    if (content && toggle) {
      const expanded = content.classList.toggle('expanded');
      toggle.textContent = expanded ? '▲' : '▼';
    }
  };

  function handleSearch() {
    const searchTerm = searchInput ? searchInput.value.trim().toLowerCase() : '';
    activeFilters.search = searchTerm;
    applyFilters();
  }

  function handleFilterChange(checkbox) {
    const filterType = checkbox.dataset.filterType;
    const value = checkbox.dataset.filter;

    // Single select - uncheck others
    document.querySelectorAll('[data-filter-type="' + filterType + '"]').forEach(function(cb) {
      if (cb !== checkbox) cb.checked = false;
    });

    if (filterType === 'vendor') {
      activeFilters.vendor = checkbox.checked ? value : '';
    } else if (filterType === 'product_type') {
      activeFilters.type = checkbox.checked ? value : '';
    }

    applyFilters();
  }

  function applyFilters() {
    let products = allProducts.slice();

    // Apply search
    if (activeFilters.search) {
      const query = activeFilters.search;
      products = products.filter(function(p) {
        const searchText = [
          p.title || '',
          p.vendor || '',
          p.type || '',
          p.handle || ''
        ].join(' ').toLowerCase();

        return searchText.indexOf(query) !== -1;
      });
    }

    // Apply vendor filter
    if (activeFilters.vendor) {
      products = products.filter(function(p) {
        return (p.vendor || '').toLowerCase().indexOf(activeFilters.vendor) !== -1;
      });
    }

    // Apply type filter
    if (activeFilters.type) {
      products = products.filter(function(p) {
        return (p.type || '').toLowerCase().indexOf(activeFilters.type) !== -1;
      });
    }

    // Sort - Flipside first
    products.sort(function(a, b) {
      const aFlipside = (a.vendor || '').toLowerCase().indexOf('flipside') !== -1;
      const bFlipside = (b.vendor || '').toLowerCase().indexOf('flipside') !== -1;

      if (aFlipside && !bFlipside) return -1;
      if (!aFlipside && bFlipside) return 1;

      return (a.title || '').localeCompare(b.title || '');
    });

    filteredProducts = products;
    currentPage = 1;
    totalPages = Math.ceil(filteredProducts.length / CONFIG.PRODUCTS_PER_PAGE);

    updateProductDisplay();
    updateFiltersDisplay();
  }

  function buildFilters() {
    const vendorCounts = {};
    const typeCounts = {};

    allProducts.forEach(function(p) {
      if (p.vendor) {
        vendorCounts[p.vendor] = (vendorCounts[p.vendor] || 0) + 1;
      }
      if (p.type) {
        typeCounts[p.type] = (typeCounts[p.type] || 0) + 1;
      }
    });

    updateFilterSection('vendor', vendorCounts);
    updateFilterSection('type', typeCounts);
  }

  function updateFilterSection(filterType, counts) {
    const contentId = filterType === 'vendor' ? 'vendor-filter-content' : 'type-filter-content';
    const content = document.getElementById(contentId);

    if (!content) return;

    const activeKey = filterType === 'vendor' ? 'vendor' : 'type';
    const sorted = Object.keys(counts).sort(function(a, b) {
      return counts[b] - counts[a];
    });

    if (sorted.length === 0) {
      content.innerHTML = '<div>No options available</div>';
      return;
    }

    content.innerHTML = sorted.map(function(option) {
      const optionLower = option.toLowerCase();
      const id = filterType + '-' + optionLower.replace(/[^a-z0-9]/g, '-');
      const isChecked = activeFilters[activeKey] === optionLower ? 'checked' : '';
      const count = counts[option];

      return [
        '<div class="filter-item">',
          '<input type="checkbox" class="filter-checkbox"',
          ' data-filter="' + optionLower + '"',
          ' data-filter-type="' + (filterType === 'vendor' ? 'vendor' : 'product_type') + '"',
          ' id="' + id + '" ' + isChecked + '>',
          '<label for="' + id + '" class="filter-label">',
            '<span>' + option + '</span>',
            '<span class="filter-count">' + count + '</span>',
          '</label>',
        '</div>'
      ].join('');
    }).join('');
  }

  function updateProductDisplay() {
    if (!productGrid) return;

    const start = (currentPage - 1) * CONFIG.PRODUCTS_PER_PAGE;
    const end = start + CONFIG.PRODUCTS_PER_PAGE;
    const productsToShow = filteredProducts.slice(start, end);

    if (filteredProducts.length === 0) {
      productGrid.innerHTML = '<div class="no-products"><h3>No products found</h3></div>';
    } else {
      productGrid.innerHTML = '';
      productsToShow.forEach(function(product) {
        productGrid.appendChild(createProductElement(product));
      });
    }

    updatePagination();
    updateProductCount();
  }

  function createProductElement(product) {
    const price = product.price ? '$' + (product.price / 100).toFixed(2) : 'Price unavailable';
    const comparePrice = product.compare_at_price && product.compare_at_price > product.price
      ? '$' + (product.compare_at_price / 100).toFixed(2) : null;

    const image = product.image || '/assets/no-image.png';
    const available = product.variants && product.variants[0] && product.variants[0].available !== false;

    const priceHtml = comparePrice
      ? '<span class="sale-price">' + price + '</span> <span class="original-price">' + comparePrice + '</span>'
      : '<span class="regular-price">' + price + '</span>';

    const variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
    const actionButton = available && variantId
      ? '<button class="quick-add-btn" data-variant-id="' + variantId + '" data-product-title="' + escapeHtml(product.title || '') + '">Quick Add</button>'
      : '<button class="quick-add-btn" disabled>Sold Out</button>';

    const div = document.createElement('div');
    div.className = 'product-item';
    div.innerHTML = [
      '<a href="' + product.url + '" class="product-link">',
        '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" onerror="this.src=\'/assets/no-image.png\';">',
        '<h3 class="product-title">' + escapeHtml(product.title) + '</h3>',
        '<div class="product-vendor">' + escapeHtml(product.vendor) + '</div>',
        '<div class="product-price">' + priceHtml + '</div>',
      '</a>',
      '<div class="product-actions">' + actionButton + '</div>'
    ].join('');

    return div;
  }

  function updatePagination() {
    const pageInfo = document.getElementById('page-info');
    const prevBtn = document.getElementById('prev-page');
    const nextBtn = document.getElementById('next-page');

    if (pageInfo) {
      pageInfo.textContent = 'Page ' + currentPage + ' of ' + totalPages + ' (' + filteredProducts.length + ' products)';
    }

    if (prevBtn) prevBtn.disabled = currentPage <= 1;
    if (nextBtn) nextBtn.disabled = currentPage >= totalPages;

    // Update page numbers
    const pageNumbers = document.getElementById('page-numbers');
    if (pageNumbers) {
      let html = '';
      const maxVisible = 5;
      let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
      let endPage = Math.min(totalPages, startPage + maxVisible - 1);

      for (let i = startPage; i <= endPage; i++) {
        const isActive = i === currentPage ? ' active' : '';
        html += '<span class="page-number' + isActive + '" data-page="' + i + '">' + i + '</span>';
      }

      pageNumbers.innerHTML = html;
    }
  }

  function updateFiltersDisplay() {
    const display = document.getElementById('active-filters');
    if (!display) return;

    const activeList = [];

    if (activeFilters.search) {
      activeList.push('Search: "' + activeFilters.search + '"');
    }
    if (activeFilters.vendor) {
      activeList.push('Vendor: ' + activeFilters.vendor);
    }
    if (activeFilters.type) {
      activeList.push('Type: ' + activeFilters.type);
    }

    display.textContent = activeList.length ? activeList.join(', ') : 'None';
  }

  function updateProductCount() {
    if (totalProductsCount) {
      totalProductsCount.textContent = 'Total products: ' + allProducts.length + (isLoading ? ' (loading more...)' : '');
    }
  }

  function clearAllFilters() {
    activeFilters.vendor = '';
    activeFilters.type = '';
    activeFilters.search = '';

    document.querySelectorAll('.filter-checkbox').forEach(function(cb) {
      cb.checked = false;
    });

    if (searchInput) searchInput.value = '';

    applyFilters();
  }

  function clearSearch() {
    if (searchInput) searchInput.value = '';
    activeFilters.search = '';
    applyFilters();
  }

  async function handleQuickAdd(button) {
    const variantId = button.dataset.variantId;
    const productTitle = button.dataset.productTitle;

    if (!variantId) return;

    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      button.textContent = 'Added!';
      console.log('Added to cart:', productTitle);

    } catch (error) {
      console.error('Quick add failed:', error);
      button.textContent = 'Error';
    } finally {
      setTimeout(function() {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }

  // Background loading
  async function startBackgroundLoading() {
    if (isLoading) return;
    isLoading = true;

    console.log('Starting comprehensive background product loading...');

    if (loadingIndicator) {
      loadingIndicator.style.display = 'block';
      updateLoadingProgress('Starting comprehensive product discovery...');
    }

    try {
      let newProductCount = 0;
      // Use normalized handle set for de-dupe across all phases
      const existingHandles = new Set(allProducts.map(p => normHandle(p.handle)));

      // Phase 0: Flipside-first bootstrap
      updateLoadingProgress('Loading Flipside Customs first…');
      newProductCount += await loadFlipsideFirst(existingHandles);

      // Phase 1: Deep scan collections/all endpoint
      console.log('Phase 1: Deep scanning collections/all...');
      const collectionAllAdded = await loadFromCollectionsAll(existingHandles);
      newProductCount += collectionAllAdded;
      console.log('Phase 1 complete: Added', collectionAllAdded, 'products');

      // Phase 2: Load all individual collections
      console.log('Phase 2: Loading all individual collections...');
      const collections = await loadCollections();
      if (collections && collections.collections) {
        updateLoadingProgress('Found ' + collections.collections.length + ' collections to scan...');

        for (let i = 0; i < collections.collections.length; i++) {
          const collection = collections.collections[i];
          const added = await loadCollectionProducts(collection.handle, existingHandles);
          newProductCount += added;

          if (i % 10 === 0 && i > 0) {
            console.log('Processed', i + 1, '/', collections.collections.length, 'collections, total added:', newProductCount);
            updateLoadingProgress('Processed ' + (i + 1) + '/' + collections.collections.length + ' collections, found ' + newProductCount + ' new products');
            buildFilters();
            applyFilters();
          }

          // Small delay to prevent rate limiting
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      // Phase 3: Search API with comprehensive terms
      console.log('Phase 3: Comprehensive search API...');
      updateLoadingProgress('Running comprehensive search queries...');
      const searchAdded = await loadFromSearchAPI(existingHandles);
      newProductCount += searchAdded;
      console.log('Phase 3 complete: Added', searchAdded, 'products');

      // Phase 4: Sitemap discovery
      console.log('Phase 4: Sitemap discovery...');
      updateLoadingProgress('Scanning product sitemaps...');
      const sitemapAdded = await loadFromSitemaps(existingHandles);
      newProductCount += sitemapAdded;
      console.log('Phase 4 complete: Added', sitemapAdded, 'products');

      console.log('Background loading complete!');
      console.log('Total new products found:', newProductCount);
      console.log('Total products now:', allProducts.length);

      // Final de-dupe just in case
      allProducts = dedupeAll(allProducts);

      buildFilters();
      applyFilters();
      updateLoadingProgress('Complete! Found ' + allProducts.length + ' total products (+' + newProductCount + ' new)');

    } catch (error) {
      console.error('Background loading failed:', error);
      updateLoadingProgress('Loading completed with some errors. Found ' + allProducts.length + ' total products.');
    } finally {
      isLoading = false;
      setTimeout(function() {
        if (loadingIndicator) {
          loadingIndicator.style.display = 'none';
        }
      }, 5000);
    }
  }

  // Phase 0: Flipside-first bootstrap
  async function loadFlipsideFirst(existingHandles) {
    let added = 0;

    // (A) Search suggest for "flipside"
    try {
      const res = await fetch('/search/suggest.json?q=' + encodeURIComponent('flipside') + '&resources[type]=product&resources[limit]=1000');
      if (res.ok) {
        const data = await res.json();
        const products = (((data||{}).resources||{}).results||{}).products || [];
        products.forEach(p => {
          const h = normHandle(p.handle);
          if (!h || existingHandles.has(h)) return;
          const fp = formatSearchProduct(p);
          allProducts.push(fp);
          existingHandles.add(h);
          added++;
        });
      }
    } catch (e) { console.log('Flipside search bootstrap failed:', e.message); }

    // (B) /collections/all filtered to vendor=Flipside*
    try {
      let page = 1, fails = 0;
      while (page <= 30 && fails < 5) {
        const res = await fetch('/collections/all/products.json?limit=250&page=' + page);
        if (!res.ok) { fails++; page++; continue; }
        const data = await res.json();
        const prods = data.products || [];
        if (!prods.length) break;

        prods.forEach(prod => {
          const h = normHandle(prod.handle);
          if (!h || existingHandles.has(h)) return;
          const v = (prod.vendor || '').toLowerCase();
          if (v.includes('flipside')) {
            const fp = formatProduct(prod);
            allProducts.push(fp);
            existingHandles.add(h);
            added++;
          }
        });
        if (prods.length < 250) break;
        page++;
        await new Promise(r => setTimeout(r, 100));
      }
    } catch (e) { console.log('Flipside /collections/all bootstrap failed:', e.message); }

    if (added > 0) { buildFilters(); applyFilters(); }
    return added;
  }

  // Phase 1: Deep scan collections/all
  async function loadFromCollectionsAll(existingHandles) {
    let added = 0;
    let page = 1;
    let consecutiveFailures = 0;

    while (page <= 200 && consecutiveFailures < 10) { // aggressive
      try {
        const response = await fetch('/collections/all/products.json?limit=250&page=' + page);
        if (!response.ok) {
          consecutiveFailures++;
          page++;
          continue;
        }

        const data = await response.json();
        if (!data.products || data.products.length === 0) {
          consecutiveFailures++;
          page++;
          continue;
        }

        let addedInPage = 0;
        data.products.forEach(function(prod) {
          const h = normHandle(prod && prod.handle);
          if (prod && h && !existingHandles.has(h)) {
            const product = formatProduct(prod);
            allProducts.push(product);
            existingHandles.add(h);
            added++;
            addedInPage++;
          }
        });

        if (addedInPage > 0) {
          console.log('Collections/all page', page, ': +' + addedInPage + ' products');
        }

        consecutiveFailures = 0;
        page++;

        if (data.products.length < 250) break; // Last page

        // Progress update every 20 pages
        if (page % 20 === 0) {
          updateLoadingProgress('Deep scan: page ' + page + ', found ' + added + ' new products');
          applyFilters();
        }

        await new Promise(resolve => setTimeout(resolve, 150));

      } catch (error) {
        console.log('Collections/all page', page, 'failed:', error.message);
        consecutiveFailures++;
        page++;
      }
    }

    return added;
  }

  // Enhanced collection product loading
  async function loadCollectionProducts(handle, existingHandles) {
    let added = 0;
    let page = 1;
    let consecutiveFailures = 0;

    try {
      while (page <= 50 && consecutiveFailures < 5) { // aggressive per collection
        const response = await fetch('/collections/' + handle + '/products.json?limit=250&page=' + page);
        if (!response.ok) {
          consecutiveFailures++;
          page++;
          continue;
        }

        const data = await response.json();
        if (!data.products || data.products.length === 0) {
          break;
        }

        data.products.forEach(function(prod) {
          const h = normHandle(prod && prod.handle);
          if (prod && h && !existingHandles.has(h)) {
            const product = formatProduct(prod);
            allProducts.push(product);
            existingHandles.add(h);
            added++;
          }
        });

        consecutiveFailures = 0;
        page++;

        if (data.products.length < 250) break;
      }
    } catch (error) {
      console.log('Collection', handle, 'failed:', error.message);
    }

    return added;
  }

  // Phase 3: Comprehensive search API
  async function loadFromSearchAPI(existingHandles) {
    let added = 0;

    const searchTerms = [
      // Single letters
      'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
      'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
      // Numbers
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
      '10', '20', '30', '50', '100', '200', '300', '500',
      // Years
      '2020', '2021', '2022', '2023', '2024', '2025',
      // Common terms
      'the', 'and', 'for', 'with', 'kit', 'set', 'part', 'parts', 'tool', 'tools',
      'custom', 'pro', 'system', 'upgrade', 'performance', 'racing', 'tuning',
      'flipside', 'turbo', 'engine', 'exhaust', 'intake', 'aluminum', 'steel',
      'carbon', 'mm', 'inch', 'black', 'red', 'blue', 'white', 'silver'
    ];

    for (let i = 0; i < searchTerms.length; i++) {
      const term = searchTerms[i];
      try {
        const response = await fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=1000');
        if (response.ok) {
          const data = await response.json();
          if (data && data.resources && data.resources.results && data.resources.results.products) {
            const products = data.resources.results.products;

            let addedInSearch = 0;
            products.forEach(function(product) {
              const h = normHandle(product && product.handle);
              if (product && h && !existingHandles.has(h)) {
                const formattedProduct = formatSearchProduct(product);
                allProducts.push(formattedProduct);
                existingHandles.add(h);
                added++;
                addedInSearch++;
              }
            });

            if (addedInSearch > 0) {
              console.log('Search "' + term + '": +' + addedInSearch + ' products');
            }
          }
        }
      } catch (error) {
        console.log('Search term "' + term + '" failed:', error.message);
      }

      // Progress update
      if (i % 10 === 0 && i > 0) {
        updateLoadingProgress('Search API: ' + (i + 1) + '/' + searchTerms.length + ' terms, found ' + added + ' new products');
        if (added > 0 && i % 20 === 0) {
          applyFilters();
        }
      }

      await new Promise(resolve => setTimeout(resolve, 100));
    }

    return added;
  }

  // Phase 4: Sitemap discovery
  async function loadFromSitemaps(existingHandles) {
    let added = 0;

    const sitemapUrls = [
      '/sitemap.xml',
      '/sitemap_products_1.xml',
      '/sitemap_products_2.xml',
      '/sitemap_products_3.xml',
      '/sitemap_products_4.xml',
      '/sitemap_products_5.xml',
      '/sitemap_products_6.xml',
      '/sitemap_products_7.xml',
      '/sitemap_products_8.xml',
      '/sitemap_products_9.xml',
      '/sitemap_products_10.xml'
    ];

    for (const sitemapUrl of sitemapUrls) {
      try {
        const response = await fetch(sitemapUrl);
        if (!response.ok) continue;

        const xmlText = await response.text();
        const parser = new DOMParser();
        const xml = parser.parseFromString(xmlText, 'text/xml');

        // Check for sitemap index
        const sitemapElements = xml.querySelectorAll('sitemap loc');
        if (sitemapElements.length > 0) {
          // Process sub-sitemaps
          for (let i = 0; i < Math.min(sitemapElements.length, 20); i++) {
            const url = sitemapElements[i].textContent;
            if (url && url.indexOf('products') !== -1) {
              try {
                const subAdded = await processSitemap(url, existingHandles);
                added += subAdded;
              } catch (error) {
                console.log('Sub-sitemap failed:', url);
              }
            }
          }
        } else {
          // Process regular sitemap
          added += processSitemapUrls(xml, existingHandles);
        }

      } catch (error) {
        console.log('Sitemap failed:', sitemapUrl);
      }
    }

    return added;
  }

  async function processSitemap(sitemapUrl, existingHandles) {
    try {
      const response = await fetch(sitemapUrl);
      if (!response.ok) return 0;

      const xmlText = await response.text();
      const parser = new DOMParser();
      const xml = parser.parseFromString(xmlText, 'text/xml');

      return processSitemapUrls(xml, existingHandles);
    } catch (error) {
      return 0;
    }
  }

  function processSitemapUrls(xml, existingHandles) {
    let count = 0;

    try {
      const urls = [];
      const locs = xml.querySelectorAll('url loc');
      for (let i = 0; i < locs.length; i++) {
        urls.push(locs[i].textContent);
      }

      const productUrls = urls.filter(function(url) {
        return url && url.indexOf('/products/') !== -1;
      });

      productUrls.forEach(function(url) {
        const handle = extractProductHandle(url);
        const h = normHandle(handle);
        if (h && !existingHandles.has(h)) {
          const product = createPlaceholderProduct(handle, url);
          allProducts.push(product);
          existingHandles.add(h);
          count++;
        }
      });

    } catch (error) {
      console.log('Error processing sitemap URLs:', error);
    }

    return count;
  }

  function extractProductHandle(url) {
    try {
      const match = url.match(/\/products\/([^\/\?]+)/);
      return match ? match[1] : null;
    } catch (error) {
      return null;
    }
  }

  function createPlaceholderProduct(handle, url) {
    // no fake variant -> prevents bogus duplicates & quick-adds
    return {
      handle: handle,
      title: handle.replace(/-/g, ' ').replace(/\b\w/g, function(l) { return l.toUpperCase(); }),
      vendor: '',
      type: '',
      price: 0,
      compare_at_price: null,
      image: '',
      url: url || '/products/' + handle,
      collections: [],
      variants: []
    };
  }

  function formatSearchProduct(product) {
    return {
      handle: product.handle,
      title: product.title || '',
      vendor: product.vendor || '',
      type: product.product_type || '',
      price: cents(product.price) || cents(product.price_min) || 0,
      compare_at_price: cents(product.compare_at_price) || null,
      image: product.image || '',
      url: product.url || '/products/' + product.handle,
      collections: [],
      variants: product.id ? [{ id: product.id, available: product.available !== false }] : []
    };
  }

  function updateLoadingProgress(message) {
    const progressEl = document.getElementById('loading-progress');
    if (progressEl) {
      progressEl.innerHTML = message;
    }
    console.log(message);
  }

  async function loadCollections() {
    try {
      const response = await fetch('/collections.json?limit=250');
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      console.log('Failed to load collections:', error);
    }
    return null;
  }

  function formatProduct(prod) {
    const firstVariant = Array.isArray(prod.variants) && prod.variants.length ? prod.variants[0] : null;
    return {
      handle: prod.handle,
      title: prod.title || '',
      vendor: prod.vendor || '',
      type: prod.product_type || prod.type || '',
      // price from variant or price_min; not prod.price
      price: cents(firstVariant && firstVariant.price) || cents(prod.price_min) || cents(prod.price) || 0,
      compare_at_price: cents(firstVariant && firstVariant.compare_at_price) || cents(prod.compare_at_price) || null,
      image: (prod.images && prod.images[0] && (prod.images[0].src || prod.images[0].url)) || prod.featured_image || '',
      url: prod.url || '/products/' + prod.handle,
      collections: Array.isArray(prod.collections) ? prod.collections.map(c => c.handle || c) : [],
      variants: firstVariant ? [{
        id: firstVariant.id,
        available: firstVariant.available !== false
      }] : []
    };
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }

  console.log('Product Search System Ready!');
});
